var _mask, _mask2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoalsMet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h13.4426842v10.2201863h-13.4426842z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h14.3082062v18.2567288h-14.3082062z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30v30h-30z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.09994279 10.2201863c-.21830663 0-.42796338-.0873706-.58242563-.24265007l-3.27624714-3.29399586c-.32169336-.32298136-.32169336-.84761904 0-1.17101449.32169337-.32339545.8431579-.32339545 1.16485126 0l2.69382151 2.70807453 7.93688791-7.97805383c.3216933-.32339544.842746-.32339544 1.1648512 0 .3216934.32339545.3216934.84803313 0 1.1710145l-8.51931348 8.56397515c-.15446224.15527947-.36411899.24265007-.58242563.24265007",
    mask: "url(#a)",
    transform: "translate(10.979741 9.116087)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.53578947 14.5579296c-.38594965.3879917-.90988558.6062112-1.45606407.6062112s-1.07011442-.2182195-1.45606407-.6062112l-3.27624714-3.2939959c-.80485126-.8086956-.80485126-2.11925461 0-2.92795026.80361556-.80828158 2.10851258-.80828158 2.91212814 0l1.82018307 1.82981366 4.6367506-4.66086956-3.54398172-4.99130435c-.41437071-.56273292-1.20439359-.6815735-1.76416476-.26501035-.10050343.07494824-.18988558.16397515-.26443936.26501035l-5.24306636 7.38509317c0 .02484472-.02512586.02484472-.02512586.04968944-1.18544622 2.0575569-1.16649886 4.5995859.04942792 6.6389234 1.93304348 3.4608696 6.29011441 4.6910973 9.73235694 2.7482402 1.145492-.6463769 2.0912129-1.5971015 2.7337758-2.7482402.9955606-1.6699793 1.1763844-3.673706.5622425-5.4757764z",
    mask: "url(#b)",
    transform: "translate(8 5.414244)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalsMet);
export default __webpack_public_path__ + "static/media/goalsMet.bfd5fbedd751a93571de811f3b907b0e.svg";
export { ForwardRef as ReactComponent };